module.exports = __webpack_public_path__ + "img/wode.4419e6c9.png";